import './styles.scss'

import I18n from 'lib/i18n'
import React, { useEffect } from 'react'
import { useActions, useValues } from 'kea'

import GeolocateButton from 'lib/components/geolocate-button'

import LocationAutocomplete from './location-autocomplete'

import centerZoomFromLocations from 'lib/utils/geo/center-zoom-from-locations'

import scrollToView from 'lib/utils/scroll-to-view'

import sceneLogic from '~/scenes/search/logic'
import filtersLogic from '~/scenes/search/filters-page/logic'
import PropTypes from 'prop-types'

export default function Location ({ fullScreenFiltersPage, locationFilterComponent }) {
  const { unsavedFilter, suggestionsResults } = useValues(filtersLogic)
  const { updateUnsavedFilter, clearSuggestionResults } = useActions(filtersLogic)

  const { isGeolocating, performedGeolocate } = useValues(sceneLogic)
  const { silentGeolocate } = useActions(sceneLogic)

  const MAX_ZOOM_FOR_SEARCH = 13

  const handleClick = suggestion => {
    updateUnsavedFilter({
      ...unsavedFilter,
      location: ''
    })

    const geocoder = new window.google.maps.Geocoder()
    geocoder.geocode({ placeId: suggestion.value }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK && results && results[0]) {
        const place = results[0]
        const mapDiv = window.document.getElementById('search-page-main-pigeon-map')
        const width = mapDiv ? mapDiv.clientWidth : unsavedFilter.width
        const height = mapDiv ? mapDiv.clientHeight : unsavedFilter.height
        if (place.geometry.viewport) {
          const viewport = place.geometry.viewport
          const ne = viewport.getNorthEast()
          const sw = viewport.getSouthWest()
          const nw = { lat: ne.lat(), lng: sw.lng() }
          const se = { lat: sw.lat(), lng: ne.lng() }
          const centerZoom = centerZoomFromLocations(
            [
              { latitude: nw.lat, longitude: nw.lng },
              { latitude: se.lat, longitude: se.lng },
              { latitude: place.geometry.location.lat(), longitude: place.geometry.location.lng() }
            ],
            width,
            height,
            0
          )
          const changes = {
            ...unsavedFilter,
            location: suggestion.name,
            location_slug: null,
            location_types: unsavedFilter.location_types === 'webcam' ? '' : unsavedFilter.location_types,
            bounds: null,
            center: [centerZoom.center[0], centerZoom.center[1]] || unsavedFilter.center,
            zoom: Math.min(centerZoom.zoom, MAX_ZOOM_FOR_SEARCH) || unsavedFilter.zoom,
            width: width || unsavedFilter.width,
            height: height || unsavedFilter.height,
            coords_from_location: true,
            zoom_out_if_needed: true,
            fromLocationAutocomplete: true
          }
          updateUnsavedFilter(changes)
        }
      }
    })
    clearSuggestionResults()
  }

  return (
    <>
      <div className='filter-section'>
        <div className='location filter-title'>{I18n.t('react.search.filters.location.placeholder')}</div>
        <div
          className={`location-all-filter-bloc ${
            fullScreenFiltersPage && locationFilterComponent ? 'flex-direction-column' : ''
          }`}
        >
          <LocationAutocomplete
            unsavedFilter={unsavedFilter}
            updateUnsavedFilter={updateUnsavedFilter}
            performedGeolocate={performedGeolocate}
            fullScreenFiltersPage={fullScreenFiltersPage}
            locationFilterComponent
          />
          <GeolocateButton
            withMap={false}
            isGeolocating={isGeolocating}
            onClick={silentGeolocate}
            fullScreenFiltersPage={fullScreenFiltersPage}
            locationFilterComponent
          />

          {locationFilterComponent &&
            fullScreenFiltersPage &&
            suggestionsResults.length !== 0 &&
            suggestionsResults.map(suggestion => {
              return (
                <span
                  key={suggestion.placeId}
                  className='super-label suggestions-result'
                  onClick={() => handleClick(suggestion)}
                >
                  {suggestion.name}
                </span>
              )
            })}
        </div>
      </div>
    </>
  )
}

Location.propTypes = {
  fullScreenFiltersPage: PropTypes.bool,
  locationFilterComponent: PropTypes.bool
}
